import Tv from "../../assets/imgProducts/tv.png";
import ThreeDots from "../../assets/three-dots.svg";
import { CarouselPrimary } from "../../components/Carousel";
import { PurchaseDetails } from "../../components/PurchaseDetails";

import {
  Products,
  PurchaseUnderReviewContent,
  PurchaseUnderReviewContainer,
} from "./style";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { clearCardSuccess } from "../../store/cart/addCart";

const purchaseSummary = [
  {
    id: 1,
    productName: "Televisão OLED Super Digital 42”",
    productPrice: "2.099,00",
    img: Tv,
    productCode: "00000000000",
    productBrand: "Super Digital",
  },
];

const credentialProofData = {
  id: 1,
  protocol: "0000000000000",
  name: "Josephina Kloser",
  phone: "(00) 00000-0000",
  email: "josefinak@email.com.br",
  cpf: "000.000.000-00",
  postalCode: "00000-000",
  address: "Rua das Amendoas",
  city: "Campinas",
  state: "SP",
  cardNumber: "0000 0000 0000 0000",
  cardHolderName: "JOSEFINA KLOSER",
  expirationDate: "02/2030",
  installmentPlan: "1x R$ 2.099,00 sem juros",
  summary: purchaseSummary,
  status: "under-review",
};

export function PurchaseUnderReview() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clearCardSuccess());
    window.scrollTo(0, 0);
  }, [dispatch]);

  return (
    <PurchaseUnderReviewContainer>
      <PurchaseUnderReviewContent>
        <div className="contentItems">
          <h2 className="successfulPurchase">
            Pedido em análise{" "}
            <img className="threeDots" src={ThreeDots} alt="three dots" />
          </h2>
          <h3 className="processedPurchase">
            Sua compra está em análise, mas seu protocolo é:{" "}
            {credentialProofData.protocol}
            <br></br>
            Assim que liberado lhe informaremos por e-mail.
          </h3>
          <PurchaseDetails
            key={credentialProofData.id}
            {...credentialProofData}
          />
        </div>
        <Products>
          <h2 className="textTitle">
            Também se interessam <span>Ver mais produtos</span>
          </h2>
          <CarouselPrimary />
        </Products>
      </PurchaseUnderReviewContent>
    </PurchaseUnderReviewContainer>
  );
}
